import { HTTP } from '../../utils/http';

export const ApprovedPickupService = {
    getPickupsByChild(childId) {
        return HTTP.get(`/children/${childId}/pickups`);
    }
};


// WEBPACK FOOTER //
// ./src/common/services/pages/approved-pickup.service.js